// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgIconRankSilverColor = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width={144}
    height={144}
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path d="M0 0h144v80H72v-8H0V0Z" fill="url(#paint0_radial_2642_490)" />
    <path d="M72 136h72v8H72v-8Z" fill="url(#paint1_radial_2642_490)" />
    <path d="M72 88h72v8H72v-8Z" fill="url(#paint2_radial_2642_490)" />
    <path d="M72 120h72v8H72v-8Z" fill="url(#paint3_radial_2642_490)" />
    <path d="M72 104h72v8H72v-8Z" fill="url(#paint4_radial_2642_490)" />
    <path d="M8 72v72H0V72h8Z" fill="url(#paint5_radial_2642_490)" />
    <path d="M72 72v72h-8V72h8Z" fill="url(#paint6_radial_2642_490)" />
    <path d="M56 72v72h-8V72h8Z" fill="url(#paint7_radial_2642_490)" />
    <path d="M24 72v72h-8V72h8Z" fill="url(#paint8_radial_2642_490)" />
    <path d="M40 72v72h-8V72h8Z" fill="url(#paint9_radial_2642_490)" />
    <defs>
      <radialGradient
        id="paint0_radial_2642_490"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(177.482 34.457 71.013) scale(80.9256 185.247)"
      >
        <stop stopColor="#C5C7C3" />
        <stop offset={0.672} stopColor="#817D78" />
        <stop offset={1} stopColor="#615D6A" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_2642_490"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(177.482 34.457 71.013) scale(80.9256 185.247)"
      >
        <stop stopColor="#C5C7C3" />
        <stop offset={0.672} stopColor="#817D78" />
        <stop offset={1} stopColor="#615D6A" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_2642_490"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(177.482 34.457 71.013) scale(80.9256 185.247)"
      >
        <stop stopColor="#C5C7C3" />
        <stop offset={0.672} stopColor="#817D78" />
        <stop offset={1} stopColor="#615D6A" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_2642_490"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(177.482 34.457 71.013) scale(80.9256 185.247)"
      >
        <stop stopColor="#C5C7C3" />
        <stop offset={0.672} stopColor="#817D78" />
        <stop offset={1} stopColor="#615D6A" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_2642_490"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(177.482 34.457 71.013) scale(80.9256 185.247)"
      >
        <stop stopColor="#C5C7C3" />
        <stop offset={0.672} stopColor="#817D78" />
        <stop offset={1} stopColor="#615D6A" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_2642_490"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(177.482 34.457 71.013) scale(80.9256 185.247)"
      >
        <stop stopColor="#C5C7C3" />
        <stop offset={0.672} stopColor="#817D78" />
        <stop offset={1} stopColor="#615D6A" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_2642_490"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(177.482 34.457 71.013) scale(80.9256 185.247)"
      >
        <stop stopColor="#C5C7C3" />
        <stop offset={0.672} stopColor="#817D78" />
        <stop offset={1} stopColor="#615D6A" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_2642_490"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(177.482 34.457 71.013) scale(80.9256 185.247)"
      >
        <stop stopColor="#C5C7C3" />
        <stop offset={0.672} stopColor="#817D78" />
        <stop offset={1} stopColor="#615D6A" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_2642_490"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(177.482 34.457 71.013) scale(80.9256 185.247)"
      >
        <stop stopColor="#C5C7C3" />
        <stop offset={0.672} stopColor="#817D78" />
        <stop offset={1} stopColor="#615D6A" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_2642_490"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(177.482 34.457 71.013) scale(80.9256 185.247)"
      >
        <stop stopColor="#C5C7C3" />
        <stop offset={0.672} stopColor="#817D78" />
        <stop offset={1} stopColor="#615D6A" />
      </radialGradient>
    </defs>
  </svg>
))
SvgIconRankSilverColor.displayName = 'SvgIconRankSilverColor'
const Memo = memo(SvgIconRankSilverColor)
export { Memo as SvgIconRankSilverColor }
